import React from 'react';

import {
    BrowserRouter as Router, Routes, Route, Navigate
} from 'react-router-dom';


// Importación de Layouts y Páginas (Las crearemos a continuación)
import Bitacora from './pages/Bitacora';

import ConstructionDashboard from './pages/ConstructionDashboard';

import SecurityDashboard from './pages/SecurityDashboard';

import ProjectSettings from './pages/ProjectSettings';

import SuperAdminDashboard from './pages/SuperAdminDashboard';

import MainLayout from './layouts/MainLayout';

import Login from './pages/Login';

import CompanyProjects from './pages/CompanyProjects';

import PhotosViewer from './pages/PhotosViewer';

import BlueprintsViewer from './pages/BlueprintsViewer';
import ClientPortal from './pages/ClientPortal';
import TeamManagement from './pages/TeamManagement';
import LiveCameras from './pages/LiveCameras';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import ReportsDashboard from './pages/ReportsDashboard';
import GanttDashboard from './pages/GanttDashboard';
import AttendanceDashboard from './pages/AttendanceDashboard';
import BimViewer from './pages/BimViewer';
import EstimationsDashboard from './pages/EstimationsDashboard';
import Checkout from './pages/Checkout';
import LandingPage from './pages/LandingPage';
import AdminAlerts from './pages/AdminAlerts';
import LogisticsDashboard from './pages/LogisticsDashboard';
import Wiki from './pages/Wiki';
import Maintenance from './pages/Maintenance';
import SuperAdminCompanies from './pages/SuperAdminCompanies';
import SuperAdminBilling from './pages/SuperAdminBilling';
import SuperAdminCameras from './pages/SuperAdminCameras';
import SuperAdminSecurity from './pages/SuperAdminSecurity';


// Componente para proteger rutas (Y Opcionalmente validar Roles)
const PrivateRoute = ({
    children, allowedRoles
}) => {
    const token = localStorage.getItem('token');

    const userRole = localStorage.getItem('userRole');


    if (!token) {
        return <Navigate to="/login" replace />;
    }

    if (allowedRoles && !allowedRoles.includes(userRole)) {
        // Definimos las URLs de contingencia por jerarquía
        if (userRole === 'SUPER_ADMIN') return <Navigate to="/admin-global" replace />;

        if (userRole === 'COMPANY_ADMIN') return <Navigate to="/projects" replace />;

        if (userRole === 'PROJECT_MANAGER') return <Navigate to="/dashboard" replace />;

        if (userRole === 'VIEWER') return <Navigate to="/cliente" replace />;
        if (userRole === 'DEMO_USER') return <Navigate to="/dashboard" replace />;

        return <Navigate to="/login" replace />;
    }

    return children;
};


// Componente para redireccionar dinámicamente desde la raíz
const RoleBasedRedirect = () => {
    const token = localStorage.getItem('token');

    const userRole = localStorage.getItem('userRole');


    if (!token) return <Navigate to="/login" replace />;


    if (userRole === 'SUPER_ADMIN') return <Navigate to="/admin-global" replace />;

    if (userRole === 'COMPANY_ADMIN') return <Navigate to="/projects" replace />;

    if (userRole === 'PROJECT_MANAGER') return <Navigate to="/dashboard" replace />;

    if (userRole === 'VIEWER') return <Navigate to="/cliente" replace />;
    if (userRole === 'DEMO_USER') return <Navigate to="/dashboard" replace />;

    return <Navigate to="/login" replace />;
};


function MainApp() {
    return (
        <Router>
            <Routes>
                {
                    /* RUTA PÚBLICA */
                }
                <Route path="/login" element={
                    <Login />
                } />
                <Route path="/checkout" element={
                    <Checkout />
                } />
                <Route path="/maintenance" element={
                    <Maintenance />
                } />
                {
                    /* RUTA GLOBAL SUPERADMIN */
                }
                <Route
                    path="/admin-global"
                    element={
                        <PrivateRoute allowedRoles={
                            ['SUPER_ADMIN']
                        }>
                            <MainLayout>
                                <SuperAdminDashboard />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/admin/companies"
                    element={
                        <PrivateRoute allowedRoles={
                            ['SUPER_ADMIN']
                        }>
                            <MainLayout>
                                <SuperAdminCompanies />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/admin/billing"
                    element={
                        <PrivateRoute allowedRoles={
                            ['SUPER_ADMIN']
                        }>
                            <MainLayout>
                                <SuperAdminBilling />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/admin-billing"
                    element={
                        <PrivateRoute allowedRoles={
                            ['SUPER_ADMIN']
                        }>
                            <MainLayout>
                                <SuperAdminBilling />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/admin/cameras"
                    element={
                        <PrivateRoute allowedRoles={
                            ['SUPER_ADMIN']
                        }>
                            <MainLayout>
                                <SuperAdminCameras />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/admin/security"
                    element={
                        <PrivateRoute allowedRoles={
                            ['SUPER_ADMIN']
                        }>
                            <MainLayout>
                                <SuperAdminSecurity />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />

                {
                    /* RUTAS PROTEGIDAS (Envueltas en el Layout y la Seguridad) */
                }
                <Route
                    path="/projects"
                    element={
                        <PrivateRoute allowedRoles={
                            ['COMPANY_ADMIN']
                        }>
                            <CompanyProjects />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/dashboard"
                    element={
                        <PrivateRoute allowedRoles={
                            ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
                        }>
                            <MainLayout>
                                <ConstructionDashboard />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/bitacora"
                    element={
                        <PrivateRoute allowedRoles={
                            ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
                        }>
                            <MainLayout>
                                <Bitacora />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/photos"
                    element={
                        <PrivateRoute allowedRoles={
                            ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
                        }>
                            <MainLayout>
                                <PhotosViewer />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/blueprints"
                    element={
                        <PrivateRoute allowedRoles={
                            ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
                        }>
                            <MainLayout>
                                <BlueprintsViewer />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/security"
                    element={
                        <PrivateRoute allowedRoles={
                            ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
                        }>
                            <MainLayout>
                                <SecurityDashboard />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/analytics"
                    element={
                        <PrivateRoute allowedRoles={
                            ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
                        }>
                            <MainLayout>
                                <AnalyticsDashboard />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/reports"
                    element={
                        <PrivateRoute allowedRoles={
                            ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
                        }>
                            <MainLayout>
                                <ReportsDashboard />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/gantt"
                    element={
                        <PrivateRoute allowedRoles={
                            ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
                        }>
                            <MainLayout>
                                <GanttDashboard />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/attendance"
                    element={
                        <PrivateRoute allowedRoles={
                            ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
                        }>
                            <MainLayout>
                                <AttendanceDashboard />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/bim"
                    element={
                        <PrivateRoute allowedRoles={
                            ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
                        }>
                            <MainLayout>
                                <BimViewer />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/estimations"
                    element={
                        <PrivateRoute allowedRoles={
                            ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
                        }>
                            <MainLayout>
                                <EstimationsDashboard />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/settings"
                    element={
                        <PrivateRoute allowedRoles={
                            ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'DEMO_USER']
                        }>
                            <MainLayout>
                                <ProjectSettings />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/admin-alerts"
                    element={
                        <PrivateRoute allowedRoles={
                            ['SUPER_ADMIN']
                        }>
                            <MainLayout>
                                <AdminAlerts />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/logistics"
                    element={
                        <PrivateRoute allowedRoles={
                            ['SUPER_ADMIN', 'COMPANY_ADMIN', 'PROJECT_MANAGER', 'DEMO_USER']
                        }>
                            <MainLayout>
                                <LogisticsDashboard />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/cliente"
                    element={
                        <PrivateRoute allowedRoles={
                            ['VIEWER', 'COMPANY_ADMIN']
                        }>
                            <MainLayout>
                                <ClientPortal />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/team"
                    element={
                        <PrivateRoute allowedRoles={
                            ['COMPANY_ADMIN']
                        }>
                            <MainLayout>
                                <TeamManagement />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/cameras"
                    element={
                        <PrivateRoute allowedRoles={
                            ['COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
                        }>
                            <MainLayout>
                                <LiveCameras />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/wiki"
                    element={
                        <PrivateRoute allowedRoles={
                            ['SUPER_ADMIN', 'COMPANY_ADMIN', 'PROJECT_MANAGER', 'VIEWER', 'DEMO_USER']
                        }>
                            <MainLayout>
                                <Wiki />
                            </MainLayout>
                        </PrivateRoute>
                    }
                />
                {
                    /* REDIRECCIÓN POR DEFECTO */
                }
                <Route path="/" element={
                    <RoleBasedRedirect />
                } />
            </Routes>
        </Router>
    );
}

export default MainApp;
